import { render, staticRenderFns } from "./WF4_DiscountPage.vue?vue&type=template&id=2e771e19&scoped=true"
import script from "./WF4_DiscountPage.vue?vue&type=script&lang=js"
export * from "./WF4_DiscountPage.vue?vue&type=script&lang=js"
import style0 from "./WF4_DiscountPage.vue?vue&type=style&index=0&id=2e771e19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e771e19",
  null
  
)

export default component.exports